export const tablesAndTicketsStyle = {
	wrapper: {
		position: 'relative',
		width: '100%',
		height: '100%',
		overflow: 'hidden',

		'@media (min-width: 1200px)': {
			minHeight: 'calc(100vh - 128px)',
			maxHeight: 'fit-content',
		},

		'& > .MuiBox-root': {
			height: 'calc(100% - 100px)',
		},
	},

	content: {
		display: 'flex',
		gap: '12px',
	},

	loader: {
		position: 'absolute',
		left: '50%',
		top: '50%',
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '1170px',
			width: '100%',
			height: '100%',
			padding: '48px 38px 0 48px',
			scrollbarGutter: 'stable',

			'& .MuiButtonBase-root': {
				right: '0',
			},

			'& .MuiDialogTitle-root': {
				marginBottom: '40px',
			},

			'& > div': {
				height: '100%',

				'& > div': {
					height: '100%',
					display: 'flex',
					justifyContent: 'flex-start',
				},
			},
		},
	},
};
